import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelClientAccessRightsResolverErrorStatesEnum {
    GetUserWithPermissionsFailed = ErrorStateScheduleEnum.PanelUserEditAccessRightsResolverStatesStartIndex,
    GetPortalPermissionsFailed,
    GetPortalPermissionsNoDataFound
}
